module.exports = __webpack_public_path__ + "assets/truck.81d6bc39.svg";